export const API_ENDPOINTS = {
  ATTACHMENTS: 'attachments',
  PRODUCTS: '/products',
  PRODUCTS_START_TRAINING: '/products/start-training',
  PRODUCTS_POPULAR: '/popular-products',
  PRODUCTS_FREE_DOWNLOAD: '/free-downloads/digital-file',
  PRODUCTS_REVIEWS: '/reviews',
  STORE_REVIEWS: '/store-reviews',
  PRODUCTS_REVIEWS_ABUSE_REPORT: '/abusive_reports',
  PRODUCTS_QUESTIONS: '/questions',
  PRODUCTS_FEEDBACK: '/feedbacks',
  CATEGORIES: '/categories',
  TAGS: '/tags',
  TYPES: '/types',
  AI_MODELS: '/ai-models',
  SHOPS: '/shops',
  TOP_SHOPS: '/top-shops',
  ORDERS: '/orders',
  ORDERS_CHECKOUT_VERIFY: 'orders/checkout/verify',
  ORDERS_DOWNLOADS: '/downloads',
  GENERATE_DOWNLOADABLE_PRODUCT_LINK: '/downloads/digital-file',
  USERS: '/users',
  USERS_ME: '/me',
  USERS_LOGIN: '/token',
  USERS_REGISTER: '/register',
  USERS_FORGOT_PASSWORD: '/forget-password',
  USERS_VERIFY_FORGOT_PASSWORD_TOKEN: '/verify-forget-password-token',
  USERS_RESET_PASSWORD: '/reset-password',
  USERS_CHANGE_PASSWORD: '/change-password',
  USERS_LOGOUT: '/logout',
  USERS_WISHLIST: '/my-wishlists',
  WISHLIST: '/wishlists',
  USERS_WISHLIST_TOGGLE: '/wishlists/toggle',
  MY_REPORTS: '/my-reports',
  MY_QUESTIONS: '/my-questions',
  SETTINGS: '/settings',
  SETTINGS_CONTACT_US: '/contact-us',
  UPLOADS: '/attachments',
  FOLLOW_SHOP: 'follow-shop',
  FOLLOWED_SHOPS: 'followed-shops',
  FOLLOWED_SHOPS_PRODUCTS: 'followed-shops-popular-products',
  ORDERS_PAYMENT: '/orders/payment',
  CARDS: '/cards',
  SET_DEFAULT_CARD: '/set-default-card',
  SAVE_PAYMENT_METHOD: '/save-payment-method',
  PAYMENT_INTENT: '/payment-intent',
  SUBSCRIBE_TO_NEWSLETTER: '/subscribe-to-newsletter',
  GENERATE_DESCRIPTION: 'generate-descriptions',
  GENERATE_IMAGES: '/generate-images',
  GENERATED_IMAGES_UPDATE_PUBLIC_STATUS: '/generated-images/update-public-status',
  GENERATE: '/generate',
  QUEUE_STATUS: '/queue/status',
  QUEUE_RESPONSE: '/queue/response',
  GENERATED_IMAGES: '/generated-images',
  STRIPE_CREATE_SUBSCRIPTION_SESSION: '/create-stripe-subscription-session',
  STRIPE_CREATE_CREDITS_SESSION: '/create-stripe-credit-session',
  STRIPE_CREATE_PORTAL_SESSION: '/create-stripe-portal-session',
};
